// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lCVwuKh3YqMRDJYEZjhF{height:100%;position:relative}.vUP2cr7hHYmx7iOAAAX5{flex-direction:column;height:100%;display:flex;overflow:auto}._TOYY5BUR6sUbRB6kXHj{position:absolute;top:24px;right:20px}.uarmFLvnEsM_RlW7w1hV{flex-direction:column;flex-grow:1;max-width:1032px;margin:0 auto;padding:0 20px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `lCVwuKh3YqMRDJYEZjhF`,
	"container": `vUP2cr7hHYmx7iOAAAX5`,
	"closeIconWrapper": `_TOYY5BUR6sUbRB6kXHj`,
	"content": `uarmFLvnEsM_RlW7w1hV`
};
export default ___CSS_LOADER_EXPORT___;
